import { render } from "./house-trend.vue?vue&type=template&id=08ae19a6"
import script from "./house-trend.vue?vue&type=script&lang=js"
export * from "./house-trend.vue?vue&type=script&lang=js"

import "./house-trend.vue?vue&type=style&index=0&id=08ae19a6&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-house/_component/house-trend.vue'],['render',render],['__file',"house-trend.vue"]])

export default __exports__